<template>
    <div class="vue rewards-catalog py-4">

      <LoaderOverlay v-if="loading"/>

      <div class="container">
        <!--<button @click.prevent="getRewards">Carica</button>-->

        <!--      BANNER BLACK FRIDAY       -->
        <div class="justify-content-center d-flex" v-if="enableRewardBanner()">
          <div class="d-sm-block d-block d-xl-none">
            <img :src="banner_images.mobile" class="img-fluid">
          </div>
          <div class="d-none d-xl-block">
            <img :src="banner_images.desktop" class="img-fluid">
          </div>
        </div>

        <div v-if="rewards.length > 0" class="filter-buttons my-5 d-flex justify-content-start justify-content-md-center overflow-auto">
          <button class="btn mx-2 btn-filter" :disabled="current_sector == null" @click.prevent="current_sector = null; only_special = false;">TUTTI</button>
          <!--<button class="btn mx-2 btn-filter btn-red" :disabled="only_special == true" @click.prevent="only_special = true;  current_sector = 'TIM'">SPECIALE DA TIM</button>-->
          <!-- <button class="btn mx-2 btn-filter" v-for="sector in sectors" v-bind:key="sector"  :disabled="current_sector == sector" @click.prevent="current_sector = sector; only_special = false;">{{ sector }}</button> -->
          <button :class="'btn mx-2 btn-filter' + (  user && sector == user.sector_special_name ? ' btn-red' : '') + (  user && sector == 'PORTA UN AMICO' ? ' badge-green' : '')" v-for="sector in sectors" v-bind:key="sector"  :disabled="current_sector == sector" @click.prevent="current_sector = sector;">{{ sector }}</button>
      </div>

        <div class="cards-catalog">
          <div class="row row-eq-height">
            <div class="col-sm-4 p-4" v-for="reward in rewardsFiltered" v-bind:key="reward.rewardId">
              <rewards-card :reward="reward"></rewards-card>
            </div>
          </div>
        </div>

      </div>


    </div>
</template>

<script>

    /* eslint-disable */

    import _ from 'lodash';
    import TimPartyMixin from '../mixins/TimPartyMixin';
    import LoaderOverlay from './LoaderOverlay.vue'
    import RewardsCard from './RewardsCard.vue'

    export default {
      name: 'RewardCatalog',
      mixins: [ TimPartyMixin ],
      components: {LoaderOverlay, RewardsCard},
      props: {
        apiUrl: String,
      },
      data: function(){

        return {

          current_sector: null,
          // only_special: null,

          rewards: [],
          sectors: [],
          banner_images: []

        };
      },
      mounted: function(){
        this.setApiUrl(this.apiUrl);
        this.enableRewardBanner();
        this.getRewards();
      },

      methods: {
        getRewards: function(){

          var self = this;

          var payload = {
            action: 'getRewards',
            access_token: this.accessToken,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;


            if(response.rewards != undefined){
              self.rewards = response.rewards;
              self.extractSectors();
              self.handleSectorFromUrl();
            }

          });

        },


        extractSectors: function(){
          this.sectors = [];
          for(var i in this.rewards){
            var sector = this.rewards[i].sector;

            if( sector && this.sectors.indexOf(sector) == -1 ){

              if( this.user && sector == this.user.sector_special_name){
                this.sectors.unshift(sector);
              }
              else{
                this.sectors.push(sector);
              }


            }
          }
        },

        handleSectorFromUrl: function(){
          const urlParams = new URLSearchParams(window.location.search);
          const sector = urlParams.get('sector');

          if( sector && this.sectors.indexOf(sector) != -1 ){
              this.current_sector = sector;
          }

        },

        enableRewardBanner: function () {
          if (this.notifications != null) {
            if(this.notifications.BANNER.length > 0) {
              for(var i in this.notifications.BANNER) {
                if (this.notifications.BANNER[i].templateCode === 'REWARD_BANNER') {
                  this.banner_images.mobile = (this.notifications.BANNER[i].extra.images['popup-mobile'] != undefined ? this.notifications.BANNER[i].extra.images['popup-mobile'][0] : (this.notifications.BANNER[i].extra.images['popup-desktop'] != undefined ? this.notifications.BANNER[i].extra.images['popup-desktop'][0] : null));
                  this.banner_images.desktop = (this.notifications.BANNER[i].extra.images['popup-desktop'] != undefined ? this.notifications.BANNER[i].extra.images['popup-desktop'][0] : (this.notifications.BANNER[i].extra.images['popup-mobile'] != undefined ? this.notifications.BANNER[i].extra.images['popup-mobile'][0] : null));
                  return true;
                }
              }
            } else {
              return false;
            }
          }
          return false;
        }
      },
      computed: {
        rewardsFiltered: function(){
          // if(this.only_special){
          //     return _.filter(this.rewards, { partnerName: 'TIM' });
          // }
          if(this.current_sector){
              return _.filter(this.rewards, { sector: this.current_sector });
          }
          else{
            return this.rewards;
          }

        }
      },
      watch: {
        access_token: function( new_val, old_val){
          this.getRewards();
        },
        notifications: function () {
          this.enableRewardBanner();
        },
        banner_images: function () {
        }
      }
    }
  </script>


